import { IconMinus, IconPlus, IconZoomReset } from '@tabler/icons-react';
import { useTranslation } from '../../../../../i18n/hooks/useTranslation';

const buttonClass = 'inline-flex h-7 w-7 items-center justify-center rounded-lg text-[#3D3833] transition-colors hover:bg-[#F7F5F3] disabled:cursor-not-allowed disabled:opacity-35 dark:text-zinc-300 dark:hover:bg-zinc-800';

/**
 * Zoom controls for a printed-form preview, for the panel's `headerAction`.
 *
 * The percentage reads against the fitted page, not against print size: 100%
 * is "the whole page fits", which is the one number a reader checking a form
 * actually cares about.
 */
export default function PagePreviewZoom({ zoom, zoomIn, zoomOut, reset, canZoomIn, canZoomOut, isFitted }) {
    const { t } = useTranslation();

    return (
        <div className="flex items-center gap-0.5 rounded-xl border border-[#ECE8E4] bg-white px-1 py-0.5 dark:border-zinc-700 dark:bg-zinc-900">
            <button
                type="button"
                onClick={zoomOut}
                disabled={!canZoomOut}
                className={buttonClass}
                title={t('toolPage.preview.zoomOut')}
                aria-label={t('toolPage.preview.zoomOut')}
            >
                <IconMinus size={15} stroke={2} />
            </button>
            <span className="min-w-[42px] text-center text-[11.5px] font-semibold tabular-nums text-[#6B635C] dark:text-zinc-400">
                {Math.round(zoom * 100)}%
            </span>
            <button
                type="button"
                onClick={zoomIn}
                disabled={!canZoomIn}
                className={buttonClass}
                title={t('toolPage.preview.zoomIn')}
                aria-label={t('toolPage.preview.zoomIn')}
            >
                <IconPlus size={15} stroke={2} />
            </button>
            <button
                type="button"
                onClick={reset}
                disabled={isFitted}
                className={buttonClass}
                title={t('toolPage.preview.zoomFit')}
                aria-label={t('toolPage.preview.zoomFit')}
            >
                <IconZoomReset size={15} stroke={1.9} />
            </button>
        </div>
    );
}
